import React, { useEffect, useRef, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { crmRequest } from './crmApi';

const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
export default function CompanySelect({ value, onChange, endpoint = '/companies', inputId = 'crm-opportunity-company' }) {
    const [input, setInput] = useState(value || '');
    const [companies, setCompanies] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [retry, setRetry] = useState(0);
    const autocomplete = useRef(null);
    useEffect(() => {
        let active = true;
        setLoading(true); setError('');
        async function load() {
            const items = [];
            let page = 1;
            while (active) {
                const result = await crmRequest(`${endpoint}?${new URLSearchParams({ page, pageSize: 100 })}`);
                items.push(...result.items);
                if (items.length >= result.total || !result.items.length) break;
                page += 1;
            }
            if (active) { setCompanies(items); setSuggestions(items); }
        }
        load().catch(e => { if (active) setError(e.message); }).finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [retry, endpoint]);
    useEffect(() => {
        if (!value) return; // Keep free typing while the parent has no selected company.
        const selected = typeof value === 'object' ? value : companies.find(company => company._id === value);
        if (selected) setInput(selected);
    }, [value, companies]);
    const search = query => {
        const term = normalize(query);
        setSuggestions(companies.filter(company => normalize([company.name, ...(company.quickBooksNames || []), company.domain, company.phone,
            ...(company.contacts || []).flatMap(contact => [contact.name, contact.email, contact.phone])].join(' ')).includes(term)));
    };
    return <div className="crm-company-select">
        <AutoComplete ref={autocomplete} inputId={inputId} value={input} suggestions={suggestions} field="name"
            dropdown dropdownAriaLabel="Mostrar clientes" dropdownMode="blank" minLength={0} delay={0} disabled={loading || Boolean(error)}
            placeholder={loading ? 'Cargando clientes…' : 'Selecciona o escribe un cliente'}
            completeMethod={event => search(event.query)} showEmptyMessage emptyMessage="No se encontraron clientes"
            onFocus={() => { search(typeof input === 'string' ? input : ''); autocomplete.current?.show(); }}
            onChange={event => { setInput(event.value || ''); onChange(event.value && typeof event.value === 'object' ? event.value : null); }}
            itemTemplate={company => <div><strong>{company.name}</strong>{company.domain && <small className="block">{company.domain}</small>}</div>}
        />
        {error && <div role="alert"><p>{error}</p><button type="button" onClick={() => setRetry(n => n + 1)}>Reintentar clientes</button></div>}
        <small>Si no existe, créalo en Clientes y contactos.</small>
    </div>;
}
